import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom/client';

import {
  createBrowserRouter, RouterProvider,
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from "react-router-dom";

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import './assets/css/peb-tokens.css';
import './assets/css/index.scss';
import './assets/css/peb-ui.scss';

import { Provider } from 'react-redux'
import { store } from './store'

import reportWebVitals from './reportWebVitals';

import * as Sentry from "@sentry/react";

import Swal from "sweetalert2";

import router from 'router';
import GlobalLayout from 'GlobalLayout';
import { startReadyFlag } from 'helpers/readyFlag';

Sentry.init({
  environment: process.env.REACT_APP_ENV || 'local',
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes
    }),
    Sentry.captureConsoleIntegration(),
    Sentry.contextLinesIntegration(),
    Sentry.browserApiErrorsIntegration()
  ],
  normalizeDepth: 5,
  attachStacktrace: true,
  enableTracing: true,
  tracesSampleRate: 1.0,
  beforeSend(event, { originalException }) {
    const appEnv = (process.env.REACT_APP_ENV || 'local').toLowerCase();

    if (appEnv !== 'local' && event.level === 'error' && (!originalException.request || originalException.request.status >= 500)) {
      let reqId = originalException?.response?.headers?.['x-request-id'] || null;

      console.log(originalException?.message);

      Swal.fire({
        icon: "error",
        title: "Error",
        html: `<p class="mt-3">Please report with event ID: <b>${event.event_id}</b></p>` + (reqId ? ` Request ID: <b>${reqId}</b>` : ''),
        customClass: {
          confirmButton: 'btn-primary'
        }
      });
    }
    return event;
  }
});

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouter(createBrowserRouter);

const browserRouter = sentryCreateBrowserRouter(router);

startReadyFlag(browserRouter);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <GlobalLayout>
        <RouterProvider router={browserRouter} />
      </GlobalLayout>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
